import chroma from 'chroma-js';
export function getPinColors(base?: string) {
  if (!base) return {};
  return {
    fill: chroma(base).hex(),
    stroke: chroma(base).darken(0.8).hex(),
  };
}
